import * as React from "react"
import Layout from '../components/layout';
import { graphql, useStaticQuery, Link } from "gatsby";
import SubCard from "../components/sub-card";
import { MDXRenderer } from "gatsby-plugin-mdx"
import SEO from "../components/seo";


const IndexPage = () => {
  const data = useStaticQuery(graphql`
    query{
      allMdx (
        sort: {
          fields: [frontmatter___date]
          order: DESC
        }
      ){
        edges {
          node {
            frontmatter {
              date
              title
              slug
              tag
              type
              thumbnail {
                childImageSharp {
                  fluid {
                    src
                  }
                }
              }
            }
            body
          }
        }
      }
    }
  `);

  const top = data.allMdx.edges.find(edge => {
    return edge.node.frontmatter.slug === "top"
  })

  // limit: 10
  const others = data.allMdx.edges.filter(edge => {
    return edge.node.frontmatter.type !== "top" 
  }).filter((edge, index) => {
    return index < 10
  })

  return (
    <Layout>
      <SEO />
      <div>
        <div className="my-4 p-4 lg:mx-4">
          <div className="p-4 bg-white rounded-lg markdown">
            <MDXRenderer>{top.node.body}</MDXRenderer>
          </div>
        </div>
        <div className="lg:flex lg:flex-wrap">
          {
            others.map(other => {
              return <SubCard 
                title={other.node.frontmatter.title} 
                src={other.node.frontmatter.thumbnail.childImageSharp.fluid.src}
                tag={other.node.frontmatter.tag} 
                slug={other.node.frontmatter.slug}/>
            })
          }
        </div>
        <div className='flex justify-between p-4'>
          <div></div>
          <Link to={`/page/2`}>次の10件</Link>
        </div>
      </div>
    </Layout>
  )
}

export default IndexPage
